import { JackPots } from '../components/Games/service';

export const parseJackpotXML = (xmlContent: string): JackPots => {
  const parser = new DOMParser();
  const jackPots: JackPots = {};

  try {
    const xmlDoc = parser.parseFromString(xmlContent, 'application/xml');
    const gameNodes = xmlDoc.querySelectorAll('game');

    gameNodes.forEach((gameNode) => {
      const jackPotName = gameNode
        .getAttribute('id')
        ?.toLowerCase()
        .replace(/(,)(.*)/, '');
      const jackPotValue = gameNode.querySelector('jackpot')?.getAttribute('current_amount')?.toLowerCase();

      if (jackPotName && jackPotValue) jackPots[jackPotName] = jackPotValue;
    });
  } catch (error) {
    console.error(error);
  }

  return jackPots;
};
